/* ─── Pocket Portals™ — theme.js ─── */

// Products hardcoded from original (fallback when no Shopify collection assigned)
const PRODUCTS = [
  { id: 1, name: "Dormanax Fuse", price: "$40.00", image: "https://i.ibb.co/S7RXzCBw/Dormanax-Fuse.jpg" },
  { id: 2, name: "Diego", price: "$40.00", image: "https://i.ibb.co/HL4r4xbr/Diego.jpg" },
  { id: 3, name: "Zormanax", price: "$40.00", image: "https://i.ibb.co/pjMqYFdb/Zormanax.jpg" },
  { id: 4, name: "Hechika", price: "$40.00", image: "https://i.ibb.co/LX6955D5/Hechika.jpg" },
  { id: 5, name: "Pocket Portals™ Card Deck", price: "$20.00", image: "https://i.ibb.co/zTX54kpM/Pocket-Portals-card-game-set.png" }
];
const ANDROID_PRODUCT = { id: 100, name: "Pocket Portals™ Android App", price: "$7.00", image: "https://i.ibb.co/zTX54kpM/Pocket-Portals-card-game-set.png" };

let cart = (() => { try { return JSON.parse(localStorage.getItem('pp_cart') || '[]'); } catch(e) { return []; } })();
let activeProduct = null;
let checkoutItems = [];

function px(s) { return parseFloat(String(s).replace(/[^0-9.]/g,'')) || 0; }
function saveCart() { try { localStorage.setItem('pp_cart', JSON.stringify(cart)); } catch(e) {} }
function totalItems() { return cart.reduce((s,i)=>s+i.quantity,0); }
function totalPrice() { return cart.reduce((s,i)=>s+px(i.price)*i.quantity,0); }

function addToCart(p) {
  const ex = cart.find(i=>i.id===p.id);
  if (ex) ex.quantity++; else cart.push({...p, quantity:1});
  saveCart(); renderCart(); updateBadge(); openCart();
}

function removeFromCart(id) { cart = cart.filter(i=>i.id!==id); saveCart(); renderCart(); updateBadge(); }

function updateQty(id, qty) {
  if (qty < 1) { removeFromCart(id); return; }
  const it = cart.find(i=>i.id===id);
  if (it) it.quantity = qty;
  saveCart(); renderCart(); updateBadge();
}

function updateBadge() {
  const n = totalItems();
  const badge = document.getElementById('cart-count');
  const hdr = document.getElementById('cart-header-count');
  if (badge) { badge.textContent = n; if (n > 0) badge.classList.add('visible'); else badge.classList.remove('visible'); }
  if (hdr) hdr.textContent = n;
}

function renderCart() {
  const list = document.getElementById('cart-items-list');
  const footer = document.getElementById('cart-footer');
  if (!list) return;
  if (cart.length === 0) {
    list.innerHTML = '<div class="cart-empty"><div class="empty-icon"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#4b5563" stroke-width="2"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg></div><p>Your cart is empty</p><button onclick="closeCart()">Continue Shopping</button></div>';
    if (footer) footer.style.display = 'none';
  } else {
    list.innerHTML = cart.map(item => `
      <div class="cart-item">
        <div class="cart-item-img"><img src="${item.image}" alt="${item.name}" referrerpolicy="no-referrer"/></div>
        <div class="cart-item-info">
          <div class="cart-item-top">
            <div><h3>${item.name}</h3><div class="cart-item-price">${item.price}</div></div>
            <button class="remove-btn" onclick="removeFromCart(${item.id})"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg></button>
          </div>
          <div class="cart-item-bottom">
            <div class="qty-ctrl">
              <button class="qty-btn" onclick="updateQty(${item.id},${item.quantity-1})"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="5" y1="12" x2="19" y2="12"/></svg></button>
              <span class="qty-num">${item.quantity}</span>
              <button class="qty-btn" onclick="updateQty(${item.id},${item.quantity+1})"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg></button>
            </div>
            <span class="cart-item-total">$${(px(item.price)*item.quantity).toFixed(2)}</span>
          </div>
        </div>
      </div>`).join('');
    const display = document.getElementById('cart-total-display');
    if (display) display.textContent = '$'+totalPrice().toFixed(2);
    if (footer) footer.style.display = 'block';
  }
}

function buildCarousel() {
  const track = document.getElementById('carousel-track');
  if (!track) return;
  // If Shopify already populated the track via Liquid, don't overwrite
  if (track.children.length > 0) return;
  const all = [...PRODUCTS, ...PRODUCTS];
  track.innerHTML = all.map((p,i) => `
    <div class="product-card">
      <div class="product-card-img">
        <img src="${p.image}" alt="${p.name}" referrerpolicy="no-referrer"/>
        <div class="product-card-overlay">
          <button class="icon-btn icon-btn-white" onclick="event.stopPropagation();addToCart(PRODUCTS[${i%PRODUCTS.length}])" title="Add to Cart"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg></button>
          <button class="icon-btn icon-btn-ghost" onclick="event.stopPropagation();openProductModal(PRODUCTS[${i%PRODUCTS.length}])" title="View Details"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg></button>
        </div>
      </div>
      <h4>${p.name}</h4>
      <p class="price">${p.price}</p>
    </div>`).join('');
}

// Modals
function openCart() { document.getElementById('cart-backdrop').classList.add('open'); document.getElementById('cart-drawer').classList.add('open'); document.body.style.overflow='hidden'; }
function closeCart() { document.getElementById('cart-backdrop').classList.remove('open'); document.getElementById('cart-drawer').classList.remove('open'); document.body.style.overflow=''; }

function openProductModal(p) {
  activeProduct = p;
  document.getElementById('pm-img').src = p.image;
  document.getElementById('pm-img').alt = p.name;
  document.getElementById('pm-name').textContent = p.name;
  document.getElementById('pm-price').textContent = p.price;
  document.getElementById('product-modal').classList.add('open');
  document.body.style.overflow = 'hidden';
}
function closeProductModal() { document.getElementById('product-modal').classList.remove('open'); activeProduct = null; document.body.style.overflow = ''; }
function handleBuyNow() { if(activeProduct){ closeProductModal(); openCheckoutWith([{...activeProduct, quantity:1}]); } }
function openCheckout() { closeCart(); openCheckoutWith(cart); }

function openCheckoutWith(items) {
  checkoutItems = items;
  document.getElementById('checkout-success').style.display = 'none';
  document.getElementById('checkout-form').style.display = 'block';
  const sub = items.reduce((s,i)=>s+px(i.price)*(i.quantity||1), 0);
  document.getElementById('co-items').innerHTML = items.map(it=>`
    <div class="co-item">
      <div class="co-item-img"><img src="${it.image}" alt="${it.name}" referrerpolicy="no-referrer"/></div>
      <div><h4>${it.name}${(it.quantity||1)>1?' x'+(it.quantity||1):''}</h4><div class="item-price">${it.price}</div></div>
    </div>`).join('');
  document.getElementById('co-subtotal').textContent = '$'+sub.toFixed(2);
  document.getElementById('co-total').textContent = '$'+sub.toFixed(2);
  document.getElementById('checkout-modal').classList.add('open');
  document.body.style.overflow = 'hidden';
}

function closeCheckoutModal() { document.getElementById('checkout-modal').classList.remove('open'); document.body.style.overflow=''; }

function handleCheckoutSubmit(e) {
  e.preventDefault();
  const isAndroid = checkoutItems.some(i=>i.id===100);
  document.getElementById('checkout-form').style.display = 'none';
  document.getElementById('checkout-success').style.display = 'flex';
  document.getElementById('success-msg').textContent = isAndroid
    ? 'Your purchase is complete! You can now download the Pocket Portals™ APK below.'
    : 'Your order has been trans-dimensionally processed. Check your email for the tracking link.';
  cart=[]; saveCart(); renderCart(); updateBadge();
}

function openAndroidModal() { document.getElementById('android-modal').classList.add('open'); document.body.style.overflow='hidden'; }
function closeAndroidModal() { document.getElementById('android-modal').classList.remove('open'); document.body.style.overflow=''; }
function purchaseAndroid() { closeAndroidModal(); openCheckoutWith([{...ANDROID_PRODUCT, quantity:1}]); }
function openRulesModal() { document.getElementById('rules-modal').classList.add('open'); document.body.style.overflow='hidden'; }
function closeRulesModal() { document.getElementById('rules-modal').classList.remove('open'); document.body.style.overflow=''; }

// Close modals on backdrop click
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.modal-backdrop').forEach(bd => {
    bd.addEventListener('click', function(e) {
      if (e.target === this) { this.classList.remove('open'); document.body.style.overflow=''; }
    });
  });
});

// Show video
var SHOW_VIDEO = 'https://www.youtube.com/watch?v=uLF3-dP0E88';
function getYTId(url) { if(url.includes('youtu.be')) return url.split('/').pop().split('?')[0]; const m=url.match(/v=([^&]+)/); return m?m[1]:''; }
function playShowVideo() {
  let html='';
  if (SHOW_VIDEO.includes('vimeo.com')) { const id=SHOW_VIDEO.split('/').pop().split('?')[0]; html=`<iframe src="https://player.vimeo.com/video/${id}?autoplay=1" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`; }
  else if (SHOW_VIDEO.includes('youtube') || SHOW_VIDEO.includes('youtu.be')) { const id=getYTId(SHOW_VIDEO); html=`<iframe src="https://www.youtube.com/embed/${id}?autoplay=1" frameborder="0" allow="autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`; }
  else { html=`<video src="${SHOW_VIDEO}" controls autoplay style="width:100%;height:100%;object-fit:contain"></video>`; }
  const wrap=document.getElementById('show-video-wrap');
  if (!wrap) return;
  wrap.innerHTML=html+'<button id="close-video-btn" onclick="closeShowVideo()" style="position:absolute;top:32px;right:32px;z-index:50;background:rgba(0,0,0,.5);border:1px solid rgba(255,255,255,.1);color:white;width:48px;height:48px;border-radius:50%;display:flex;align-items:center;justify-content:center;cursor:pointer;backdrop-filter:blur(12px)"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button>';
  wrap.style.display='block';
  const pbw = document.getElementById('play-btn-wrap'); if(pbw) pbw.style.display='none';
  const so = document.getElementById('show-overlay'); if(so) so.style.display='none';
  const st = document.getElementById('show-thumbnail'); if(st) st.style.display='none';
}
function closeShowVideo() {
  const wrap=document.getElementById('show-video-wrap');
  if (!wrap) return;
  wrap.style.display='none'; wrap.innerHTML='';
  const pbw=document.getElementById('play-btn-wrap'); if(pbw) pbw.style.display='flex';
  const so=document.getElementById('show-overlay'); if(so) so.style.display='block';
  const st=document.getElementById('show-thumbnail'); if(st) st.style.display='block';
}

// Parallax
window.addEventListener('scroll',()=>{
  const h=document.getElementById('hero');
  const bg=document.getElementById('hero-bg');
  if(h&&bg){const p=window.scrollY/h.offsetHeight;bg.style.transform=`scale(${1+p*0.1})`;}
},{passive:true});

// Intersection Observer (fade-in)
const obs=new IntersectionObserver(entries=>{entries.forEach(e=>{if(e.isIntersecting)e.target.classList.add('visible');});},{threshold:0.1});
document.querySelectorAll('.fade-in-up').forEach(el=>obs.observe(el));

// Init
buildCarousel();
renderCart();
updateBadge();
